import { useRef } from 'react'
import { useStore } from '../store'
import { probeVideo } from '../lib/media'

function fmt(t: number): string {
  const m = Math.floor(t / 60)
  const s = Math.floor(t % 60)
  return `${m}:${s.toString().padStart(2, '0')}`
}

/** Danh sách clip để ghép: thêm, chọn, đổi thứ tự, xóa. */
export function ClipList() {
  const inputRef = useRef<HTMLInputElement>(null)
  const clips = useStore((s) => s.clips)
  const activeId = useStore((s) => s.activeClipId)
  const busy = useStore((s) => s.busy)
  const addClip = useStore((s) => s.addClip)
  const removeClip = useStore((s) => s.removeClip)
  const moveClip = useStore((s) => s.moveClip)
  const setActive = useStore((s) => s.setActive)
  const setStatus = useStore((s) => s.setStatus)

  const addFiles = async (files: FileList) => {
    for (const file of Array.from(files)) {
      if (!file.type.startsWith('video/')) continue
      const url = URL.createObjectURL(file)
      try {
        const meta = await probeVideo(url)
        addClip(file, meta)
      } catch (e) {
        setStatus(`⚠️ ${file.name}: ${(e as Error).message}`)
      } finally {
        URL.revokeObjectURL(url)
      }
    }
  }

  return (
    <div className="cliplist">
      <div className="cliplist-head">
        <span>🎞️ Clip ({clips.length}) — ghép theo thứ tự</span>
        <button className="btn small" disabled={busy} onClick={() => inputRef.current?.click()}>
          ➕ Thêm video
        </button>
      </div>
      <div className="cliplist-strip">
        {clips.map((c, i) => (
          <div
            key={c.id}
            className={`clip-card ${c.id === activeId ? 'active' : ''}`}
            onClick={() => setActive(c.id)}
          >
            <div className="clip-card-top">
              <span className="clip-idx">{i + 1}</span>
              {c.transcribed && <span className="badge">CC</span>}
            </div>
            <div className="clip-card-name" title={c.name}>
              {c.name}
            </div>
            <div className="clip-card-dur">{fmt(c.duration)}</div>
            <div className="clip-card-actions" onClick={(e) => e.stopPropagation()}>
              <button className="mini" disabled={i === 0} onClick={() => moveClip(c.id, -1)}>
                ◀
              </button>
              <button
                className="mini"
                disabled={i === clips.length - 1}
                onClick={() => moveClip(c.id, 1)}
              >
                ▶
              </button>
              <button className="mini danger" onClick={() => removeClip(c.id)}>
                🗑
              </button>
            </div>
          </div>
        ))}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="video/*"
        multiple
        hidden
        onChange={(e) => {
          if (e.target.files) addFiles(e.target.files)
          e.target.value = ''
        }}
      />
    </div>
  )
}
